import { useState } from "react";
import { ReactComponent as Conditions } from "../../assets/images/conditions.svg";
import { ReactComponent as Payment } from "../../assets/images/payment.svg";
import { Title } from "../../components/Title/Title";
import { useTranslation } from "react-i18next";
import { SEO } from "../../components/SEO/SEO";

export const Delivery = () => {
  const [direction, setDirection] = useState(true);

  const { t } = useTranslation();

  return (
    <>
      <SEO title={t("DeliveryPageTitleSEO")} noIndex />
      <section className="delivery">
        <div className="container__two">
          <Title
            title={t("DeliveryTitle")}
            type={false}
            direction={direction}
            setDirection={setDirection}
          />
          <div className="delivery__thumb">
            <div className="delivery__item">
              <div className="delivery__wrapper">
                <Conditions />
                <h2 className="delivery__title">{t("DeliveryTitle")}</h2>
              </div>
              <p className="delivery__text--wrapper">
                <p className="delivery__text">{t("DeliveryTermsFirstText")}</p>
                <p className="delivery__text">
                  {t("DeliveryTermsSecondTextPart1")}{" "}
                  <span className="delivery__text--crossed">
                    {t("DeliveryTermsRussia")}
                  </span>{" "}
                  {t("DeliveryTermsSecondTextPart2")}{" "}
                  <span className="delivery__text--crossed">
                    {t("DeliveryTermsBelarus")}
                  </span>{" "}
                  {t("DeliveryTermsSecondTextPart3")}
                </p>
                <p className="delivery__text delivery__text--bold">
                  {t("DeliveryTermsUkraineDelivery")}
                </p>
                <ul className="delivery__list">
                  <li>
                    <span className="delivery__text--bold">
                      {t("DeliveryTermsListFirstBold")}
                    </span>{" "}
                    {t("DeliveryTermsListFirstText")}
                  </li>
                  <li>
                    <span className="delivery__text--bold">
                      {t("DeliveryTermsListSecondBold")}
                    </span>{" "}
                    {t("DeliveryTermsListSecondText")}
                  </li>
                  <li>
                    <span className="delivery__text--bold">
                      {t("DeliveryTermsListThirdBold")}
                    </span>{" "}
                    {t("DeliveryTermsListThirdText")}
                  </li>
                </ul>
                <p className="delivery__text delivery__text--bold">
                  {t("DeliveryTermsAbroadDelivery")}
                </p>
                <ul className="delivery__list">
                  <li>
                    <span className="delivery__text--bold">
                      {t("DeliveryTermsListFirstBold")}
                    </span>{" "}
                    {t("DeliveryTermsListFourthText")}
                  </li>
                  <li>
                    <span className="delivery__text--bold">
                      {t("DeliveryTermsListThirdBold")}
                    </span>{" "}
                    {t("DeliveryTermsListFifthText")}
                  </li>
                  <li>
                    <span className="delivery__text--bold">
                      {t("DeliveryTermsListFourthBold")}
                    </span>{" "}
                    {t("DeliveryTermsListSixthText")}
                  </li>
                  <li>
                    <span className="delivery__text--bold">
                      {t("DeliveryTermsListFifthBold")}
                    </span>{" "}
                    {t("DeliveryTermsListSeventhText")}
                  </li>
                </ul>
                <p className="delivery__text delivery__text--bold">
                  {t("DeliveryTermsReturnsTitle")}
                </p>
                <p className="delivery__text">
                  {t("DeliveryTermsReturnsText")}
                </p>
              </p>
            </div>
            <div className="delivery__item">
              <div className="delivery__wrapper">
                <Payment />
                <h2 className="delivery__title">{t("DeliveryPayment")}</h2>
              </div>
              <div className="delivery__text--wrapper">
                <p className="delivery__text">
                  {t("DeliveryPaymentFirstText")}
                </p>
                <p className="delivery__text">
                  {t("DeliveryPaymentSecondText")}
                </p>
                <p className="delivery__text">
                  {t("DeliveryPaymentThirdText")}
                </p>
                <p className="delivery__text">
                  {t("DeliveryPaymentFourthText")}
                </p>
              </div>
            </div>
          </div>
          <div className="delivery__info">
            <h3 className="delivery__info--title">{t("DeliveryContacts")}:</h3>
            <p className="delivery__info--text">{t("DeliveryContactsText")}</p>
            <ul className="delivery__list delivery__contacts--list">
              <li className="delivery__text">
                <a href="mailto:dywlf.records@com">
                  {t("DeliveryContactsEmail")} dywlf.records@com
                </a>
              </li>
              <li className="delivery__text">
                <a href="tel:+380502491022">
                  {t("DeliveryContactsPhone")} +380-50-249-10-22
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};
